// extracted by mini-css-extract-plugin
export default {"stackChatPanel":"StackChatPanel_stackChatPanel__yIsWz","categoryAccordionShift":"StackChatPanel_categoryAccordionShift__43VMf"};